import { Button, Form, Col, Container, Row, Image} from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { $validation, $form, handleBackPress, handleFindFundingFormChange, handleNextPress, handleFindFundingFormOnBlur } from './UnscopedFindFunding.helpers';
import caSbdcImage from 'assets/images/ca-sbdc.png';
// import mstreetxLogo from 'assets/images/mstreetx-logo.png';
import caatGradientLogoWithText from 'assets/images/caat-gradient-logo-with-text.png';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const SecondPage = () => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordConfirmationShown, setPasswordConfirmationShown] = useState(false);

  const { email, password, passwordConfirmation } = $form.value;
  const { touched, errors } = $validation.value;

  return (
    <>
      <Form.Group className="form-group">
        <Form.Label className="font-weight-bold" htmlFor="email">
          Email*
        </Form.Label>
        <Form.Control
          className="form-control"
          id="email"
          name="email"
          isInvalid={touched.email && errors.email.length > 0}
          value={email}
          onInput={(e) => {
            // @ts-expect-error name exists
            handleFindFundingFormChange(e);
            // @ts-expect-error name exists
            handleFindFundingFormOnBlur(e);
          }}
          onChange={handleFindFundingFormChange}
          onBlur={handleFindFundingFormOnBlur}
        />
        <Form.Control.Feedback type="invalid">
          {errors.email}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label className="font-weight-bold" htmlFor="password">
          Password*
        </Form.Label>
        <div className="position-relative">
          <Form.Control
            type={passwordShown ? 'text' : 'password'}
            className="form-control"
            id="password"
            name="password"
            isInvalid={touched.password && errors.password.length > 0}
            value={password}
            onInput={(e) => {
              // @ts-expect-error name exists
              handleFindFundingFormChange(e);
              // @ts-expect-error name exists
              handleFindFundingFormOnBlur(e);
            }}
            onChange={handleFindFundingFormChange}
            onBlur={handleFindFundingFormOnBlur}
            autoComplete="new-password"
          />
          <Button 
            variant="link"
            className="position-absolute p-0 border-0 bg-transparent" 
            style={{ top: '8px', right: '30px' }}
            onClick={() => setPasswordShown(!passwordShown)}
            >
            <FontAwesomeIcon 
              icon={(passwordShown ? faEyeSlash : faEye) as IconProp} 
              className="text-secondary"
            />
          </Button>
        </div>
        <Form.Control.Feedback type="invalid">
          {errors.password.map(error => <span key={error} className="d-block">{error}</span>)}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label className="font-weight-bold" htmlFor="passwordConfirmation">
          Password Confirmation*
        </Form.Label>
        <div className="position-relative">
          <Form.Control
            type={passwordConfirmationShown ? 'text' : 'password'}
            className="form-control"
            id="passwordConfirmation"
            name="passwordConfirmation"
            isInvalid={touched.passwordConfirmation && errors.passwordConfirmation.length > 0}
            value={passwordConfirmation}
            onInput={(e) => {
              // @ts-expect-error name exists
              handleFindFundingFormChange(e);
              // @ts-expect-error name exists
              handleFindFundingFormOnBlur(e);
            }}
            onChange={handleFindFundingFormChange}
            onBlur={handleFindFundingFormOnBlur}
            autoComplete="new-password"
          />
          <Button 
            variant="link"
            className="position-absolute p-0 border-0 bg-transparent" 
            style={{ top: '8px', right: '30px' }}
            onClick={() => setPasswordConfirmationShown(!passwordConfirmationShown)}
          >
            <FontAwesomeIcon 
              icon={(passwordConfirmationShown ? faEyeSlash : faEye) as IconProp} 
              className="text-secondary"
            />
          </Button>
        </div>
        <Form.Control.Feedback type="invalid">
          {errors.passwordConfirmation}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  )
}

const FirstPage = () => {
  const { name, zipCode } = $form.value;

  const { errors, touched } = $validation.value;

  return (
    <>
      <Form.Group className="form-group">
        <Form.Label className="font-weight-bold" htmlFor="businessName">
          Business Name*
        </Form.Label>
        <Form.Control
          type="text"
          className="form-control"
          id="name"
          name="name"
          aria-describedby="business name"
          isInvalid={touched.name && errors.name.length > 0}
          value={name}
          onChange={handleFindFundingFormChange}
          onBlur={handleFindFundingFormOnBlur}
        />
        <Form.Control.Feedback type="invalid">
          {errors.zipCode}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label className="font-weight-bold" htmlFor="zipCode">
          Zip Code*
        </Form.Label>
        <Form.Control
          type="text"
          className="form-control"
          id="zipCode"
          name="zipCode"
          aria-describedby="zip code"
          isInvalid={touched.zipCode && errors.zipCode.length > 0}
          value={zipCode}
          onChange={handleFindFundingFormChange}
          onBlur={handleFindFundingFormOnBlur}
        />
        <Form.Control.Feedback type="invalid">
          {errors.zipCode}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  )
}

const UnscopedFindFunding = () => {
  const { page, isLoading } = $form.value;

  return (
    <div style={{ background: '#e3e3e3' }} className="vh-100">
      <Container className="d-flex flex-column justify-content-center vh-100">
        <Row>
          <Col className="d-flex justify-content-center align-items-center">
            <Image width={180} src={caSbdcImage} alt="SBDC Logo" />
            <div style={{ marginLeft: '24px', marginRight: '8px', width: '4px', height: '100px'}} className="bg-secondary"></div>
            <Image width={300} src={caatGradientLogoWithText} alt="CAAT Logo" />
          </Col>
        </Row>
        <Row className="mt-24">
          <Col md={{ span: 8, offset: 2 }} className="text-center">
            <h2 className="h4 mb-8">Looking for Funding?</h2>
            <p>Get access to the most relevant funding
            for your organization in less than 30 seconds, free of charge!</p>
          </Col>
        </Row>

        <Row className="mt-16 mb-32">
          <Col xs={{ span: 10, offset: 1 }} sm={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }} className="text-center">
            <div className="d-flex justify-content-between position-relative">
              <span className={`w-50 position-absolute ${page === 1 ? 'bg-secondary' : 'bg-primary'}`} style={{ height: '5px', top: '20px' }}>

              </span>
              <span className={`w-50 position-absolute ${page > 2 ? 'bg-primary' : 'bg-secondary'}`} style={{ height: '5px', top: '20px', right: 0 }}>

              </span>

              {[1, 2].map(step => 
                <div 
                  key={step} 
                  className={`text-light ${page >= Number(step) ? 'bg-primary' : 'bg-secondary'}`}
                  style={{ zIndex: 100, width: '45px', height: '45px', borderRadius: '50%', lineHeight: '36px', border: '4px #e3e3e3 solid' }}
                >
                  {page > step ? '✔' : step}
                </div>
              )}
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={{ offset: 3, span: 6 }} lg={{ offset: 4, span: 4 }}>
            <h3 className="h6 text-center mb-24">Create your profile</h3>
            {page === 1 && <FirstPage />}
            {page === 2 && <SecondPage />}
          </Col>
        </Row>
        <Row>
          <Col md={{ offset: 3, span: 6 }} lg={{ offset: 4, span: 4 }} className="d-flex justify-content-between">
            {page > 1 ? 
            <Button 
              disabled={isLoading}
              variant="outline-primary" 
              className="rounded"
              onClick={handleBackPress}
            >
              Back
            </Button>
            : <div></div>}
            <Button 
              disabled={isLoading}
              variant="primary" 
              className="rounded"
              onClick={handleNextPress}
            >
              {isLoading ? 'Submitting...' : (page === 2 ? 'Submit' : 'Next')}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default UnscopedFindFunding;
